<template>
    <div class="meeting-company">
        <div class="container" v-if="if_group" >
            <div v-for="(value,index) in group" :key="index" class="group">
                <div v-for="(item,index) in value.company_areas" :key="index" @click="goTo(item.id,value,item.link)" :class="{'column1':value.column==1,'column2':value.column==2,'column3':value.column==3,'column4':value.column==4}">
                            <img :src="item.banner">
                            <p v-if="value.group!='主K'">{{item.name}}</p>
                </div>
                <div v-if="value.group!='主K'&&value.company_areas.length>0" class="line"></div>
            </div>
        </div>
        <div class="container" v-else>
            <a v-for="(value,index) in company" :key="index" :href="'/vascularNews/company/index?meeting_id='+meeting_id+'&company_area_id='+value.id" >
            <div class="company-area">
                <div class="image"><img :src="value.banner"></div>
                <span>{{value.name}}</span>
            </div>
            </a>
        </div>
        <tabbar :active="index"></tabbar>
    </div>
</template>
<script>
	import Tabbar from '../components/Tabbar'
    import {MeetingCompanyAreas,VascularRecommend,CompanyAreaSchedule,MeetingsDetails,MeetingsGroups,ButtonDetail} from '../../../config/interface'
	export default{
		components:{
			Tabbar
		},
		data(){
			return{
				index:3,
                company:[],
                recommends:[],
                meeting_id:'',
                group:[],
                if_group:false,
                group_id:this.$route.query.group_id?this.$route.query.group_id:this.$route.query.g_id, //是否需要分组
                button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id//是否需要分组
			}
		},
		watch:{
            $route(to, from) {
                // 对路由变化作出响应...
                this.setMeetingId();
                if(this.meeting_id!=null&&this.meeting_id!=''){
                    if(this.$route.query.group_id||this.$route.query.g_id){
                        this.if_group=false;
                        this.getCompany(this.$route.query.group_id?this.$route.query.group_id:this.$route.query.g_id);
                    }
                    else{
                     this.init();
                    }
                }
                // 对路由变化作出响应...
            }
			
		},
		mounted(){
			this.setMeetingId();
            if(this.meeting_id!=null&&this.meeting_id!=''){
                if(this.group_id){
                    this.if_group=false;
                    this.getCompany(this.group_id);
                }
                else{
                     this.init();
                }
            }
			
		},
		methods:{
            init(){

                this.GetMeetingsGroups();
                this.getButtonData();
            },
            getCompany(group_id){
                const url=MeetingCompanyAreas;
                const method='POST';
                let params={};
                if(group_id==0){
                    params={
                    meeting_id:this.meeting_id,
                }
                }
                else{
                   params={
                    meeting_id:this.meeting_id,
                    group_id:this.group_id
                }
                }

				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
                            this.company=res.data;
					}
                })
            },
            //获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							if(common.is_weixin()){
								let data=res.data;
                                document.title=data.share_title;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
            setMeetingId(){
                if(this.$route.query.meeting_id||this.$route.query.MT_id){
                    this.meeting_id=this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id;
                    this.$store.dispatch('selectedMeeting',this.meeting_id);
                }
                else{
                    if(this.$store.state.meeting_id){
                        this.$router.push({
						    path:'/vascularNews/company',
						    query:{
							    meeting_id:this.$store.state.meeting_id
						    }
					    })
                    }
                    else{
                        this.GetRecommendMeetings()
                    }
                }
            },
            //获取推荐会议
			GetRecommendMeetings(){
				const url=VascularRecommend;
				const method='POST'
				fetch(url,{},method)
				.then((res)=>{
					if(res.code==0){
						if(res.data.length>0){
							this.$router.push({
						    path:'/vascularNews/company',
						    query:{
							    meeting_id:res.data[0]
						    }
					    })
						}
					}
				})				
			},
            //会议企业专区分组 如果有分组就显示分组 如果没有就再请求全部的企业
			GetMeetingsGroups(){
				const url=MeetingsGroups;
				const method='POST';
                const params={
                    meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
                }
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						if(res.data.length>0){
                            this.if_group=true;
                            this.group=res.data;
                        }
                        else{
                            this.if_group=false;
                            this.getCompany(0);

                        }
					}
				})				
			},
            goTo(id,value,link){
                if(value.group=='主K'){
                    window.location.href=link
                }
                else{
                    this.$router.push({
					path:'/vascularNews/company/index',
					query:{
						meeting_id:this.meeting_id,
                        company_area_id:id
					}
				})
                }
            },
		}
		
	}
</script>
<style lang="scss">
.meeting-company{
	.container{
	    margin-bottom: 50px;
        .group{
            // margin-bottom:10px;
            display: flex;
            display: -webkit-flex; /* Safari */
            flex-wrap: wrap;
            width:100%;
            padding:5px 10px 0 10px;
            // justify-content: space-around;
            .column1{
                display: inline-block;
                width:100%;
                padding:10px;
                img{
                    width:100%;
                    border-radius: 10px;
                }
            }
            .line{
                height: 1px;
                width:100%;
                background: rgb(233, 231, 231);
                margin: 20px 10px 10px 10px;
            }

            .column2{
                display: inline-block;
                width:50%;
                padding:5px;
                img{
                    width:100%;
                    border-radius: 10px;
                    box-shadow: 2px 2px 1px #dfdede;
                }
                p{
                    text-align: center;
                    font-size: 12px;
                    color: rgb(102, 101, 101);
                }

            }
            .column3{
                width:33.33%;
                display: inline-block;
                padding:5px;
                img{
                    width:100%;
                    border-radius: 10px;
                    box-shadow: 2px 2px 1px #dfdede;
                }
                p{
                    text-align: center;
                    font-size: 12px;
                    color: rgb(102, 101, 101);
                }
            }
            .column4{
                width:25%;
                display: inline-block;
                padding:5px;
                img{
                    width:100%;
                    border-radius: 10px;
                    box-shadow: 2px 2px 1px #dfdede;
                }
                p{
                    text-align: center;
                    font-size: 12px;
                    color: rgb(102, 101, 101);
                }

            }
        }
        .company-area{
            box-sizing:border-box;
            margin: 0 15px 20px 15px;
            background:white;
            border-radius: 10px;
            .image{
                img{
                    margin: 15px 5% 5px 5%;
                    width:90%;
                    border-radius: 10px;
                }

            }
            span{

                width:100%;
                display:block;
                text-align: center;
                font-size: 16px;
                height:38px;
                margin: 0 auto;
                color: black;
            }
            a :link :visited :hover :active {
                color: black;
            }
        }
	}
	
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Company/Company.vue